/*eslint-disable @typescript-eslint/no-empty-function */
import { useEffect } from 'react';

const useBeacon = (beaconID, config = {}) => {
    if (!beaconID) {
        console.error('No beacon ID provided');
    }
    const isTest = process.env.STORYBOOK_ENV || process.env.NODE_ENV === 'test';

    useEffect(() => {
        if (isTest) return;
        !(function (e, t, n) {
            function a() {
                let e = t.getElementsByTagName('script')[0],
                    n = t.createElement('script');
                (n.type = 'text/javascript'),
                    (n.async = !0),
                    (n.src = 'https://beacon-v2.helpscout.net'),
                    e.parentNode.insertBefore(n, e);
            }
            if (
                ((e.Beacon = n =
                    function (t, n, a) {
                        e.Beacon.readyQueue.push({
                            method: t,
                            options: n,
                            data: a
                        });
                    }),
                (n.readyQueue = []),
                'complete' === t.readyState)
            )
                return a();
            e.attachEvent
                ? e.attachEvent('onload', a)
                : e.addEventListener('load', a, !1);
        })(window, document, window.Beacon || function () {});

        window.Beacon('config', {
            hideAvatars: true,
            ...config
        });
        if (config.autoInit !== false) {
            window.Beacon('init', beaconID);
        }
        return () => {
            //remove beacon from page
            window.Beacon('destroy');
        };
    }, []);
    return isTest ? null : window.Beacon;
};

export default useBeacon;
